/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Represents a DataLeaks risk summary object for a given domain.
 * @export
 * @interface CRSFSecReviewDataleaksRiskSummaryObject
 */
export interface CRSFSecReviewDataleaksRiskSummaryObject {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    all_severity_20: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    all_severity_25: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    all_severity_5: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    hits: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    matched_severity_20: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    matched_severity_25: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleaksRiskSummaryObject
     */
    matched_severity_5: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDataleaksRiskSummaryObject interface.
 */
export function instanceOfCRSFSecReviewDataleaksRiskSummaryObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "all_severity_20" in value;
    isInstance = isInstance && "all_severity_25" in value;
    isInstance = isInstance && "all_severity_5" in value;
    isInstance = isInstance && "hits" in value;
    isInstance = isInstance && "matched_severity_20" in value;
    isInstance = isInstance && "matched_severity_25" in value;
    isInstance = isInstance && "matched_severity_5" in value;

    return isInstance;
}

export function CRSFSecReviewDataleaksRiskSummaryObjectFromJSON(json: any): CRSFSecReviewDataleaksRiskSummaryObject {
    return CRSFSecReviewDataleaksRiskSummaryObjectFromJSONTyped(json, false);
}

export function CRSFSecReviewDataleaksRiskSummaryObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDataleaksRiskSummaryObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all_severity_20': json['all_severity_20'],
        'all_severity_25': json['all_severity_25'],
        'all_severity_5': json['all_severity_5'],
        'hits': json['hits'],
        'matched_severity_20': json['matched_severity_20'],
        'matched_severity_25': json['matched_severity_25'],
        'matched_severity_5': json['matched_severity_5'],
    };
}

export function CRSFSecReviewDataleaksRiskSummaryObjectToJSON(value?: CRSFSecReviewDataleaksRiskSummaryObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all_severity_20': value.all_severity_20,
        'all_severity_25': value.all_severity_25,
        'all_severity_5': value.all_severity_5,
        'hits': value.hits,
        'matched_severity_20': value.matched_severity_20,
        'matched_severity_25': value.matched_severity_25,
        'matched_severity_5': value.matched_severity_5,
    };
}

